var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "back-arrow"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29671",
    "data-name": "Rectangle 29671",
    width: 16,
    height: 16,
    transform: "translate(796 586)",
    fill: "#7E59D1",
    stroke: "#7E59D1",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_747",
    "data-name": "Mask Group 747",
    transform: "translate(-796 -586)",
    clipPath: "url(#back-arrow)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_14_",
    "data-name": "svgexport-7 (14)",
    transform: "translate(796 586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15209",
    "data-name": "Group 15209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15208",
    "data-name": "Group 15208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26095",
    "data-name": "Path 26095",
    d: "M15.375,7.375H2.139L4.331,5.193a.625.625,0,0,0-.882-.886L.184,7.557h0a.626.626,0,0,0,0,.885h0l3.266,3.25a.625.625,0,0,0,.882-.886L2.139,8.625H15.375a.625.625,0,1,0,0-1.25Z",
    fill: "#7E59D1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.962064fe633d75a71d7df7274cfded98.svg";
export { ForwardRef as ReactComponent };